import * as types from '../mutation-types'
import features from '@/api/features'
import Vue from 'vue'

const state = {
  features: {}
}

const getters = {
  features: (state) => (featureGroupName) => {
    return state.features[featureGroupName] ? state.features[featureGroupName] : []
  }
}

const actions = {
  getFeatures ({ commit, state }, name) {
    return new Promise((resolve, reject) => {
      features.get(name).then((response) => {
        commit(types.ADD_FEATURES, { name: name, features: response.data.result.platformFeatures })
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  },
  clearFeatures ({ commit }) {
    commit(types.CLEAR_FEATURES)
  }
}

const mutations = {
  [types.ADD_FEATURES] (state, { name, features }) {
    Vue.set(state.features, name, features)
  },
  [types.CLEAR_FEATURES] (state) {
    state.features = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
